module.exports = __webpack_public_path__ + "static/media/handbags_mipel_mobile.17ae3e2c.jpg";